import { SET_BUNDLE_PRODUCT_PRICING } from '../actionTypes/ProductPricingActionTypes';

function BundlePricingReducer(state = {}, action) {
    switch (action.type) {
        case SET_BUNDLE_PRODUCT_PRICING:
            return action.payload;
        default:
            return state;
    }
}

export default BundlePricingReducer;
